const article = {
    slug: "simone-rocha",
    category: "BRAND BUYBACK",
    listTitle: "SIMONE ROCHA（シモーネロシャ）買取",
    listDescription:
      "パールやチュールの美しさだけでなく、シーズン背景、物語、構造、希少性まで確認して査定するEnclopediaのブランド別買取ページ。",
  
    seo: {
      title:
        "SIMONE ROCHA買取｜シモーネロシャを背景まで査定するEnclopedia",
      description:
        "SIMONE ROCHA（シモーネロシャ）の買取ならEnclopediaへ。ワンピース、パールバッグ、レース、チュール、シューズをシーズン背景や希少性まで確認。LINE事前査定から送料無料の宅配買取へご案内します。",
      keyword:
        "SIMONE ROCHA 買取,Simone Rocha 買取,シモーネロシャ 買取,シモーネ ロシャ 買取,SIMONE ROCHA 高価買取,シモーネロシャ 高価買取,SIMONE ROCHA 宅配買取,シモーネロシャ ワンピース 買取,Simone Rocha パールバッグ 買取,Simone Rocha ドレス 買取,Simone Rocha バッグ 買取,Simone Rocha シューズ 買取,デザイナーズブランド 買取,アーカイブ買取,enclopedia,アンクロペディア",
      canonicalPath: "/brand_buyback/simone-rocha",
    },
  
    hero: {
      label: "SIMONE ROCHA BUYBACK",
      number: "01 / BUYBACK",
      titleLines: [
        "SIMONE ROCHA買取。",
        "ロマンティックの内側にある強さまで査定します。",
      ],
      body:
        "Enclopediaは、SIMONE ROCHAを「パールやレースが人気のブランド」という理由だけで判断しません。\nアイルランドと香港につながる記憶、儀礼や民間伝承、女性の身体をめぐる物語が、どのような構造と素材へ変換されているのかを確認します。\nシーズン背景、コレクション性、希少性、現在の需要まで見ながら、一着ずつ査定します。",
      primaryCtaLabel: "LINEで事前査定する",
      primaryCtaHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryCtaLabel: "宅配買取を申し込む",
      secondaryCtaHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
      keywords: [
        "subversive femininity",
        "pearls and tulle",
        "Irish storytelling",
        "archive valuation",
      ],
      visualLabel: "FRAGILITY WITH STRENGTH",
      visualTitle: [
        "甘さではなく、",
        "身体を守る装飾を見る。",
      ],
      image: "media/archive_fashion/buyback-simone-rocha.png",
      imageAlt:
        "SIMONE ROCHA シモーネロシャのワンピースやパールを背景まで査定する買取ページ",
    },
  
    thesis: {
      text:
        "SIMONE ROCHAの価値は、少女性や女性性を甘さへ閉じ込めず、身体を守る構造と複雑な感情へ変えることにある。",
      keywords: ["femininity", "protection", "ritual"],
    },
  
    intro: {
      label: "02 / DESIGNER & BRAND",
      titleLines: [
        "SIMONE ROCHAは、",
        "女性性の複雑さを着せるブランド。",
      ],
      body:
        "Simone Rochaは1986年にアイルランドのダブリンで生まれました。National College of Art and Designを卒業後、Central Saint Martinsの修士課程で学び、2010年にロンドン・ファッションウィークへデビューしました。\n\nパール、リボン、チュール、レース、花、膨らんだ袖。一見すると、SIMONE ROCHAの服はロマンティックで少女的に見えます。しかし、その美しさは甘さだけでは完成しません。\n\n透けるチュールには重い刺繍を重ね、繊細なドレスにはミリタリーやワークウェアの構造を組み込み、パールにはレザーや金属、厚いソールを衝突させる。柔らかさと硬さ、無垢と官能、祝福と喪失、保護と露出が同時に存在します。\n\nSIMONE ROCHAが作っているのは、理想化された一種類の女性像ではありません。少女、母親、花嫁、働く女性、喪に服す人、怒りを抱えた人。それぞれの身体と感情を、装飾と構造の両方から服へ変換しています。",
    },
  
    valuation: {
      label: "03 / WHAT WE VALUE",
      titleLines: [
        "Enclopediaが重視する、",
        "3つのSIMONE ROCHA査定視点。",
      ],
      items: [
        {
          number: "01",
          title: "シーズンの物語を見る",
          text:
            "アイルランドの民間伝承、香港の家族行事、母性、聖餐式、喪失、自然など、どの物語から生まれた服なのかを確認します。",
        },
        {
          number: "02",
          title: "相反する素材と構造を見る",
          text:
            "チュールとテーラリング、パールとレザー、レースとミリタリーなど、柔らかさと硬さがどのように共存しているかを見ます。",
        },
        {
          number: "03",
          title: "シグネチャーと希少性を見る",
          text:
            "代表的なパール装飾、立体的な袖、刺繍、ドレス、バッグ、初期作品、ランウェイ登場品を、流通量や再入手難度まで含めて査定します。",
        },
      ],
    },
  
    targetLines: {
      label: "04 / TARGET ITEMS",
      titleLines: [
        "SIMONE ROCHAの主要アイテムを、",
        "幅広く査定します。",
      ],
      items: [
        {
          tag: "ITEM 01",
          title: "ワンピース・ドレス",
          text:
            "チュール、レース、オーガンジー、刺繍、パフスリーブなど、SIMONE ROCHAの造形が凝縮されたカテゴリーを重点的に査定します。",
        },
        {
          tag: "ITEM 02",
          title: "パールバッグ・ビーズバッグ",
          text:
            "Egg Bag、Pearl Bag、がま口バッグなど、パールやビーズを構造として使用した代表的なバッグを個別に評価します。",
        },
        {
          tag: "ITEM 03",
          title: "ブラウス・シャツ・トップス",
          text:
            "大きな襟、パフスリーブ、リボン、ブロデリーアングレーズを使用したブラウスやシャツも積極的に査定します。",
        },
        {
          tag: "ITEM 04",
          title: "コート・ジャケット・ボンバージャケット",
          text:
            "ロマンティックな素材と、ミリタリー、テーラリング、ワークウェアの構造を組み合わせたアウターを丁寧に確認します。",
        },
        {
          tag: "ITEM 05",
          title: "スカート・トラウザーズ・ニット",
          text:
            "立体的なボリューム、透けるレイヤー、装飾的な編み地など、ドレス以外のウェアもデザイン性を踏まえて査定します。",
        },
        {
          tag: "ITEM 06",
          title: "シューズ・アクセサリー",
          text:
            "パール装飾のシューズ、厚底靴、ブローグ、ヘアクリップ、ピアス、ネックレスなど、ブランドを象徴する小物も対象です。",
        },
        {
          tag: "ITEM 07",
          title: "初期アーカイブ・ランウェイ登場品",
          text:
            "PVC、ネオプレン、透明素材などを用いた初期作品や、公式ルックで使用された希少なコレクションピースもご相談ください。",
        },
        {
          tag: "ITEM 08",
          title: "メンズ・コラボレーション",
          text:
            "メンズウェア、Moncler、Crocsなどの協業品も査定可能です。メインラインとは生産数や市場が異なるため、分けて評価します。",
        },
      ],
    },
  
    highValueItems: {
      label: "05 / HIGH VALUE ITEMS",
      titleLines: [
        "高価買取につながりやすい、",
        "SIMONE ROCHAのアイテム。",
      ],
      intro:
        "査定額はモデル、シーズン、状態、市場需要によって変動します。Enclopediaでは、装飾の量だけでなく、ブランドの思想が一着へどれほど凝縮されているかを確認します。",
      items: [
        {
          index: "01",
          title: "ランウェイを象徴するドレス・ワンピース",
          text:
            "立体的な袖、チュールの重なり、刺繍、パール、レースを組み合わせ、シーズンの物語を明確に示す作品を丁寧に評価します。",
        },
        {
          index: "02",
          title: "代表的なパールバッグ・装飾バッグ",
          text:
            "SIMONE ROCHAを視覚的に識別できるパールバッグやビーズバッグは、モデル、サイズ、付属品、パーツの状態を確認します。",
        },
        {
          index: "03",
          title: "物語性の強いコレクションピース",
          text:
            "香港の清明節、母性と聖餐式、アイルランド神話など、特定シーズンの主題を強く反映した服は、背景を踏まえて個別評価します。",
        },
        {
          index: "04",
          title: "希少な初期作品・限定コラボレーション",
          text:
            "初期アーカイブ、流通数の少ないモデル、MonclerやCrocsなどの限定性が高い協業品は、現在の需要と再入手難度を確認します。",
        },
      ],
    },
  
    quote: {
      textLines: [
        "パールやリボンは、甘さを足すためではない。",
        "壊れやすい身体へ、強さを与えるためにある。",
      ],
    },
  
    assessmentDifference: {
      label: "06 / ASSESSMENT DIFFERENCE",
      titleLines: [
        "一般的な査定では、",
        "見落とされやすいSIMONE ROCHAの価値。",
      ],
      intro:
        "SIMONE ROCHAの価値は、レースやパールが付いているかだけでは判断できません。物語、素材、構造、身体との関係が重なることで、一着の意味が現れます。",
      items: [
        {
          index: "01",
          title: "“ガーリーな服”で終わらせない",
          text:
            "少女的な記号の内側にある怒り、喪失、官能、母性、保護まで読み取り、シーズンの思想を確認します。",
        },
        {
          index: "02",
          title: "古いから価値が低いとは判断しない",
          text:
            "発売から年数が経過していても、初期の重要作品、代表的なシーズン、流通量の少ないモデルは個別に評価します。",
        },
        {
          index: "03",
          title: "パールの数だけで判断しない",
          text:
            "パールが服やバッグの構造へどう組み込まれているか、デザイン上どのような役割を持つかまで確認します。",
        },
        {
          index: "04",
          title: "繊細な素材の状態を細かく見る",
          text:
            "チュールの破れ、レースの引っ掛け、ビーズの欠損、刺繍糸の浮き、PVCの変色など、素材固有の経年変化を確認します。",
        },
      ],
    },
  
    flow: {
      label: "07 / BUYBACK FLOW",
      titleLines: [
        "LINE事前査定から、",
        "SIMONE ROCHAの宅配買取へ。",
      ],
      items: [
        {
          step: "STEP 01",
          title: "LINEで事前査定",
          text:
            "全体写真、ブランドタグ、品質表示タグ、品番、サイズ、状態が分かる写真をお送りください。商品名やシーズンが不明でも確認します。",
        },
        {
          step: "STEP 02",
          title: "宅配買取を申込",
          text:
            "事前査定後、本査定をご希望の場合は申込フォームへ。宅配キットの要否も選択できます。",
        },
        {
          step: "STEP 03",
          title: "無料で発送",
          text:
            "送料は無料。チュールやパールが引っ掛からないように梱包し、付属品がある場合は一緒にお送りください。",
        },
        {
          step: "STEP 04",
          title: "本査定・ご入金",
          text:
            "到着後、状態、真贋、シーズン、コレクション性、市場性を確認。金額にご納得いただければ、ご指定口座へ入金します。",
        },
      ],
    },
  
    assurance: {
      label: "08 / SAFE BUYBACK",
      titleLines: [
        "相談しやすく、",
        "一着の背景まで確認する宅配買取。",
      ],
      intro:
        "商品名やシーズンが分からない場合も、LINEで写真を確認してから宅配買取へ進めます。",
      items: [
        {
          title: "LINE事前査定あり",
          text:
            "写真とタグ情報から事前確認できるため、査定対象か分からない服や小物も相談できます。",
        },
        {
          title: "送料は無料",
          text:
            "宅配買取の発送費用はEnclopediaが負担します。",
        },
        {
          title: "宅配キットは選択制",
          text:
            "必要な方には宅配キットをご用意。ご自身で梱包できる場合は、そのまま発送可能です。",
        },
        {
          title: "キャンセル返送料は基本無料",
          text:
            "査定金額にご納得いただけない場合の返送も基本無料です。",
        },
      ],
      notice:
        "キャンセル返送料は基本無料です。ただし、お送りいただいた品がすべてコピー品、または真贋判定不可品のみだった場合は、返送料をご負担いただく場合があります。",
    },
  
    faq: {
      label: "09 / FAQ",
      titleLines: [
        "SIMONE ROCHA買取で、",
        "よくあるご質問。",
      ],
      items: [
        {
          question:
            "SIMONE ROCHA（シモーネロシャ）はどのようなブランドですか？",
          answer:
            "アイルランド出身のデザイナーSimone Rochaが2010年に発表を開始したブランドです。パール、チュール、レース、リボンなどのロマンティックな要素と、テーラリング、ミリタリー、硬質な素材を組み合わせ、女性性の複雑さを表現しています。",
        },
        {
          question:
            "どのようなSIMONE ROCHAが高価買取につながりやすいですか？",
          answer:
            "ランウェイを象徴するドレス、パールバッグ、立体的な袖や刺繍を用いたワンピース、希少な初期作品、限定コラボレーションなどは評価につながりやすい傾向があります。",
        },
        {
          question:
            "古いシーズンのSIMONE ROCHAも買取できますか？",
          answer:
            "査定可能です。古いという理由だけで一律に評価を下げず、シーズンの重要性、デザイン、希少性、現在の需要、保存状態を確認します。",
        },
        {
          question:
            "SIMONE ROCHAのパールバッグも買取できますか？",
          answer:
            "査定可能です。モデル、サイズ、パールやビーズの欠損、金具、内側の状態、保存袋などの付属品を確認します。",
        },
        {
          question:
            "メンズのSIMONE ROCHAも買取していますか？",
          answer:
            "メンズウェアも査定可能です。パール、レース、花柄などを通して繊細な男性性を表現したアイテムも、背景を踏まえて確認します。",
        },
        {
          question:
            "Moncler、Crocsとのコラボレーションも買取できますか？",
          answer:
            "ご相談いただけます。ただし、それぞれ定価、生産数、流通量が異なるため、メインコレクションとは分けて市場相場を確認します。",
        },
        {
          question:
            "チュールの傷やパールの欠損があっても買取できますか？",
          answer:
            "状態によっては査定可能です。チュールやレースの破れ、ビーズやパールの欠損、刺繍糸の浮きなどがある場合は、LINE査定時に該当箇所の写真をお送りください。",
        },
        {
          question:
            "シーズンや商品名が分からなくても査定できますか？",
          answer:
            "可能です。全体写真、ブランドタグ、品質表示タグ、品番、特徴的なディテールが分かる写真から、確認できる範囲でモデルやシーズンを調査します。",
        },
      ],
    },
  
    finalCta: {
      titleLines: [
        "まずはLINEで、",
        "SIMONE ROCHAの価値をご相談ください。",
      ],
      body:
        "パールやレースの美しさだけでなく、その服がどのような物語、感情、構造を持っているのかまで確認します。\n写真による事前査定から、SIMONE ROCHAを理解した宅配買取へ丁寧につなげます。",
      primaryLabel: "LINEで事前査定する",
      primaryHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryLabel: "宅配買取を申し込む",
      secondaryHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
    },
  };
  
  export default article;